import { createFileRoute } from '@tanstack/react-router';

import { buildBreadcrumbSchema, buildSeoHead, buildWebPageSchema, jsonLdScript, ROUTE_META } from '@src/corelib/seo';

export const Route = createFileRoute('/services/support')({
  head: () => ({
    ...buildSeoHead({ path: '/services/support', ...ROUTE_META['/services/support'] }),
    scripts: [
      jsonLdScript(buildBreadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Support', path: '/services/support' }])),
      jsonLdScript(buildWebPageSchema({ path: '/services/support', ...ROUTE_META['/services/support'] })),
    ],
  }),
});
